/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import { MenuComponent } from "../../../../../../../_metronic/assets/ts/components";
import { ID, KTIcon, QUERIES } from "../../../../../../../_metronic/helpers";
import { useQueryResponse } from "../../core/QueryResponseProvider";
import { deleteUser } from "../../core/_requests";
import { useAuth } from "../../../../../../modules/auth";

type Props = {
  id: ID;
};

const UserActionsCell: FC<Props> = ({ id }) => {
  // const {setItemIdForUpdate} = useListView()
  const { query } = useQueryResponse();
  const queryClient = useQueryClient();

  useEffect(() => {
    MenuComponent.reinitialization();
  }, []);

  // const openEditModal = () => {
  //   setItemIdForUpdate(id)
  // }

  const deleteItem = useMutation(() => deleteUser(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`]);
    },
  });
  const { currentUser } = useAuth();
  return (
    <>
      <a
        href="#"
        className="btn btn-light btn-active-light-primary btn-sm"
        data-kt-menu-trigger="click"
        data-kt-menu-placement="bottom-end"
      >
        <KTIcon iconName="element-11" className="fs-2 m-0" />
      </a>
      {/* begin::Menu */}
      <div
        className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
        data-kt-menu="true"
      >
        {/* begin::Menu item */}
        <div className="menu-item px-3">
          <Link
            className="menu-link px-3"
            to={`/admin/manage-orders/view-order/${id}`}
          >
            View
          </Link>
        </div>
        <div className="menu-item px-3">
          <Link className="menu-link px-3" to={`/generate-link/${id}`}>
            Pickup Link
          </Link>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}

        {currentUser?.permissions.find(
          (item: any) => item.name === "delete_orders"
        ) ? (
          <div className="menu-item px-3">
            <a
              className="menu-link px-3"
              data-kt-users-table-filter="delete_row"
              onClick={async () => await deleteItem.mutateAsync()}
            >
              Delete
            </a>
          </div>
        ) : null}
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  );
};

export { UserActionsCell };
